export default __webpack_public_path__ + "static/hadeArticleThumbnail-d86274271a078fa8f305e7a7063315c2.jpg";